import React from 'react';

export default function Grid({ children }) {
  return (
    <div className='tw-grid tw-grid-cols-[repeat(auto-fit,minmax(564px,564px))] tw-justify-center tw-gap-3'>
      {children}
    </div>
  );
}
